import React, { useEffect, useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col } from 'reactstrap';
import * as actions from '../actions/Sessions';
import Breadcrumb from '../components/AdminBreadcrumb';
import GridHeader from '../components/common/GridHeader';
import DeleteConfirmation from '../components/MultiDeleteConfirmation';
import { DataGrid } from '@mui/x-data-grid';

const Sessions = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });

    const [deleteEnabled, setDeleteEnabled] = useState(false);

    useEffect(() => {
        props.actions.getSessions();
    }, []);

    const handleSelect = (e) => {
        props.actions.getSession(e.id);
        props.history.push(`/sessions/session/${e.id}`, { id: e.id });
    };

    const handleAddClick = (e) => {
        props.actions.newSession();
        props.history.push({
            pathname: `/sessions/session`
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.sessions.filter(x => e.find(y => y === x.get('sessionId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDelete = () => {
        props.actions.deleteSessions(deleteConfirmationState.toDelete.map(x => x.sessionId));
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    return (
        <Container>
            <div style={{ paddingBottom: '10px' }}>
                <Breadcrumb history={props.history} />
            </div>
            <Row className='mb-1'>
                <GridHeader
                    gridEntities='Session Year'
                    deleteButtonId='deleteSessionButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addSessionButton'
                    onAddClick={handleAddClick}
                    addTooltipTarget={'addSessionButton'}
                    deleteTooltipTarget={'deleteSessionButton'}
                    tooltipEntity={'Session'}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <div className='ag-theme-balham' style={{ width: 'auto' }}>
                        <DataGrid
                            rows={props.sessions.toJS().map(x => { return { id: x.sessionId, ...x } })}
                            checkboxSelection
                            onRowDoubleClick={handleSelect}
                            onRowSelectionModelChange={handleSelectionChanged}
                            autoHeight={true}
                            rowHeight={35}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 25 } },
                            }}
                            columns={[
                                {
                                    headerName: 'Year',
                                    field: 'year',
                                    flex: 3,
                                },
                                {
                                    headerName: 'Name',
                                    field: 'name',
                                    flex: 3,
                                }
                            ]}
                            sx={{
                                backgroundColor: 'white'
                            }}
                            getRowClassName={(params) => 'grid-row'}
                        />
                    </div>
                </Col>
            </Row>
            <DeleteConfirmation
                title={`Delete Sessions`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => x.name + " " + x.year)}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );
}

function mapStateToProps(state, ownProps) {
    return {
        sessions: state.Sessions
    }
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators({ ...actions }, dispatch) }
}

export default connect(mapStateToProps, mapDispatchToProps)(Sessions);